module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/costume_01-2020da629d852bb9de409992804c8ab2.webp";